import PieChartTooltip from './PieChartTooltip';

export default PieChartTooltip;
